import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastViewport,
} from '@components/shared/toast/Toast.tsx'
import { useToast } from './useToast.hook.ts'

const notificationIconMapping = {
  success: '/images/icons/notification-success-icon.svg',
  error: '/images/icons/notification-error-icon.svg',
  info: '/images/icons/notification-info-icon.svg',
}

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, ...props }) {
        const iconUrl = notificationIconMapping[props.variant || 'info']
        return (
          <Toast key={id} {...props}>
            <div className="grid grid-cols-[40px_1fr_40px] gap-4 w-full">
              <div className="m-auto">
                <img src={iconUrl} alt="notification-icon" />
              </div>
              <ToastDescription>{title}</ToastDescription>
              <div className="flex items-center justify-end">
                <ToastClose />
              </div>
            </div>
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
